var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslation } from 'react-i18next';
import { alertsFormActions } from '../../../redux/alertsForm/actions';
import { CustomSelect, SelectWrapper } from './subcomponents';
import getDropDownAlertOptions from './getDropDownAlertOptions';
import { FAR_CHEVRON_DOWN, FAR_CHEVRON_UP, FAS_CIRCLE_EXCLAMATION } from '../../../const/iconProps';
var AlertSelectField = function (_a) {
    var isDisabled = _a.isDisabled, alertId = _a.alertId, inputKey = _a.inputKey, inputValue = _a.inputValue, inputError = _a.inputError, inputRef = _a.inputRef;
    var t = useTranslation().t;
    var dispatch = useDispatch();
    var stringKey = alertId.toLowerCase();
    var options = getDropDownAlertOptions();
    var defaultOptionIndex = options.findIndex(function (option) { return option.value === inputValue; });
    var updateInputValue = useCallback(function (value) {
        dispatch(alertsFormActions.onAttributeValueChange(alertId, inputKey, value));
    }, [alertId, dispatch, inputKey]);
    var onChangeHandler = useCallback(function (obj) {
        updateInputValue(obj.value);
    }, [updateInputValue]);
    var helpText = t("inputHelperText.".concat(stringKey)) || '';
    return (_jsx(SelectWrapper, __assign({ "data-test": "SelectWrapper" }, { children: _jsx(CustomSelect, { name: "Select with Error", id: "error-select", "data-test": "select", isDisabled: isDisabled, selectInputRef: inputRef, placeholder: t("inputPlaceHolders.".concat(stringKey)) || '', helpText: helpText, error: inputError, errorIcon: _jsx(FontAwesomeIcon, { icon: FAS_CIRCLE_EXCLAMATION }), options: options, defaultOption: options[defaultOptionIndex], rightIconOpen: _jsx(FontAwesomeIcon, { icon: FAR_CHEVRON_UP, width: "15px" }), rightIconClosed: _jsx(FontAwesomeIcon, { icon: FAR_CHEVRON_DOWN, width: "15px" }), onChange: onChangeHandler }) })));
};
export default AlertSelectField;
